module.exports = __webpack_public_path__ + "media/images/map_layer_icon-45f32bccfb21236c0dc8ba9db066b761.png";